import { useState } from "react";

const Calculator = ({ onClose }) => {
  const [value, setValue] = useState('');

  const handleClick = (val) => {
  if (val === '=') {
    try {
      setValue(eval(value).toString());
    } catch {
      setValue('Error');
    }
  } else if (val === 'C') {
    setValue('');
  } else if (val === '⌫') {
    setValue((prev) => prev.slice(0, -1)); // Remove last character
  } else {
    setValue((prev) => prev + val);
  }
};


  const buttons = ['7','8','9','/','4','5','6','*','1','2','3','-','0','.','=','+','C','⌫'];

  return (
    <div>
      <input
        type="text"
        className="w-full border mb-4 px-2 py-1 text-right"
        value={value}
        readOnly
      />
      <div className="grid grid-cols-4 gap-2">
        {buttons.map((btn) => (
          <button
            key={btn}
            className="bg-gray-200 p-2 rounded hover:bg-gray-300"
            onClick={() => handleClick(btn)}
          >
            {btn}
          </button>
        ))}
      </div>
      <button
        className="mt-4 w-full text-white bg-primary py-2 rounded"
        onClick={onClose}
      >
        Close
      </button>
    </div>
  );
};

export default Calculator;
